import * as React from "react";
import PropTypes from "prop-types";
import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Check from "@mui/icons-material/Check";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import FactCheckIcon from "@mui/icons-material/FactCheck";
import SendToMobileIcon from "@mui/icons-material/SendToMobile";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import Typography from "@mui/material/Typography";
import StepButton from "@mui/material/StepButton";
import Transmitepbpin from "./TransmitEpbPin";
import GenerateEpbPin from "./GenerateEpbPin";
import ReturningOfficer from "./ReturningOfficer";
import Finalizeepb from "./FinalizeEPB";
import LeftMenu from "../../AnalyticsModule/Left";
import { useGetEpbDetailQuery } from "../../../services/finalizeGenerateViewTransmitService";
import { useGetElectionDetailsQuery } from "../../../services/announceElection";
import NoElection from "../../NoElection";
import moment from "moment";
import TimerCountdown from '../../../library/components/FlipCountDownClock/flipCountDown'
import WorkingFlipDate from "../../../library/components/WorkingFlipDate/WorkingFlipDate";
import tick from "../../../dashboardicon/tick.svg"
import click from "../../../dashboardicon/click.svg"

const QontoConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 10,
    left: "calc(-50% + 16px)",
    right: "calc(50% + 16px)",
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderColor: "#784af4",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    borderColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderTopWidth: 3,
    borderRadius: 1,
  },
}));

const QontoStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  color: theme.palette.mode === "dark" ? theme.palette.grey[700] : "#eaeaf0",
  display: "flex",
  height: 22,
  alignItems: "center",
  ...(ownerState.active && {
    color: "#784af4",
  }),
  "& .QontoStepIcon-completedIcon": {
    color: "#784af4",
    zIndex: 1,
    fontSize: 18,
  },
  "& .QontoStepIcon-circle": {
    width: 8,
    height: 8,
    borderRadius: "50%",
    backgroundColor: "currentColor",
  },
}));

function QontoStepIcon(props) {
  const { active, completed, className } = props;

  return (
    <QontoStepIconRoot ownerState={{ active }} className={className}>
      {completed ? (
        <Check className="QontoStepIcon-completedIcon" />
      ) : (
        <div className="QontoStepIcon-circle" />
      )}
    </QontoStepIconRoot>
  );
}

QontoStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
};

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,rgb(143 132 132) 0%,rgb(155 148 149) 50%,rgb(138,35,135) 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient(  136deg,  rgb(80 165 22) 0%, rgb(45 151 59) 50%, rgb(51 96 52) 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 50,
  height: 50,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage:
      "linear-gradient( 136deg, rgb(253 97 0) 0%, rgb(235 158 63) 50%, rgb(138,35,135) 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
    animation: "Transmitzoom 1s ease infinite",
  }),
  ...(ownerState.completed && {
    backgroundImage:
      "linear-gradient( 136deg,  rgb(80 165 22) 0%, rgb(45 151 59) 50%, rgb(51 96 52) 100%)",
  }),
}));

function ColorlibStepIcon(props) {
  const { active, completed, className } = props;

  const icons = {
    1: <UploadFileIcon />,
    2: <FactCheckIcon />,
    3: <SendToMobileIcon />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(props.icon)]}
    </ColorlibStepIconRoot>
  );
}

ColorlibStepIcon.propTypes = {
  /**
   * Whether this step is active.
   * @default false
   */
  active: PropTypes.bool,
  className: PropTypes.string,
  /**
   * Mark the step as completed. Is passed to child components.
   * @default false
   */
  completed: PropTypes.bool,
  /**
   * The label displayed in the step icon.
   */
  icon: PropTypes.node,
};

export default function CustomizedSteppers() {
  const [activeStep, setActiveStep] = React.useState(0);
  const { data , refetch } = useGetEpbDetailQuery();
  const [date, setDate] = React.useState("");
  const [isCompleted, setIsCompleted] = React.useState(false);
  const { data: ElectionDetail, isSuccess ,refetch:refetchServerDate} = useGetElectionDetailsQuery("Transmitting");
  const [steps, setSteps] = React.useState([
    { label: "Upload Ballot", completed: true, active: true, error: false },
    { label: "Finalize e-PB", completed: true, active: true, error: false },
    {
      label: "Transmit e-PB & PIN",
      completed: false,
      active: true,
      error: false,
    },
  ]);
  React.useEffect(() => {
    setSteps([
      {
        label: "Upload Ballot",
        completed: data?.payload?.ballotFileFlag === "Y" ? true : false,
        active: data?.payload?.ballotFileFlag !== "Y" ? true : false,
        error: false,
      },
      {
        label: "Finalize e-PB",
        completed: data?.payload?.epbPaperFlag === "Y" ? true : false,
        active: (data?.payload?.ballotFileFlag === "Y" && data?.payload?.epbPaperFlag !== "Y")? true : false,
        error: false,
      },
      {
        label: "Transmit e-PB & PIN",
        completed: data?.payload?.epbPinGenerated === "Y" ? true : false,
        active: (data?.payload?.epbPaperFlag === "Y" && data?.payload?.epbPinGenerated !== "Y") ? true : false,
        error: false,
      },
    ]);
  }, [data]);
  const handleStep = (step) => () => {
    setActiveStep(step);
  };
  React.useEffect(() => {
    var startDate = moment(ElectionDetail?.payload?.[0]?.startDate)
      .subtract(1, "days")
      .format("YYYY-MM-DD HH:mm:ss");
    setDate(startDate);
  }, [data]);

  var currtDate = moment(new Date()).format("MM/DD/YYYY HH:mm");

  const renderTabs = () => {
    switch (activeStep) {
      case 0:
        return <ReturningOfficer refetch={refetch} epbdetails={data} />;
      case 1:
        return <Finalizeepb refetch={refetch} epbdetails={data} />;
      case 2:
        return <Transmitepbpin postfetch={refetch} epbdetails={data} />;
    }
  };

  const refreshDate = ()=>{
    refetchServerDate()
  }
  console.log(steps)
  
  return (
    <>
      <LeftMenu>
        {isSuccess && ElectionDetail?.message === "Success" && ElectionDetail?.refId !== "No Elector Found for this Constituency" ? (
          data && 
          <>
          <WorkingFlipDate
          hours={ElectionDetail?.payload?.[0]?.hours} 
          minutes={ElectionDetail?.payload?.[0]?.minutes} 
          days={ElectionDetail?.payload?.[0]?.days}
          seconds={ElectionDetail?.payload?.[0]?.seconds}
          message={"Left for e-PB Transmission process to start"}
          messageClass={"returningOfficer_countdown"}
          disable={ElectionDetail?.payload?.[0]?.timerVariable}
          refreshDate={refreshDate}
          >
              <>
                <Stack sx={{ width: "100%", marginTop: "25px" }} spacing={8}>
                  <Stepper
                    alternativeLabel
                    activeStep={2}
                    connector={<ColorlibConnector />}
                  >
                    {steps.map((label, index) => (
                      <Step
                        key={label?.label}
                        completed={label?.completed}
                        active={label?.active}
                      >
                        <StepButton color="inherit" onClick={handleStep(index)}>
                          <StepLabel StepIconComponent={ColorlibStepIcon}>
                            {label?.label}{label?.active?<img src={click} className="Transmitzoom" style={{height:"20px",width:"20px", marginLeft:"6px",animation: "Transmitzoom 1s ease infinite",}} />:label?.completed?<img src={tick}  style={{height:"20px", marginLeft:"6px",width:"20px"}}/>:null}
                          </StepLabel>
                        </StepButton>
                      </Step>
                    ))}
                  </Stepper>
                </Stack>
                <Typography sx={{ mt: 2, mb: 1, py: 1 }}>
                  {renderTabs()}
                </Typography>
              </>
            </WorkingFlipDate>
          </>
        ) : isSuccess && ElectionDetail?.message !== "Success" && ElectionDetail?.refId !== "No Elector Found for this Constituency" ? (
          <NoElection data={"No Election Scheduled for your Constituency"} />
        ) : isSuccess && ElectionDetail?.message === "Success" && ElectionDetail?.refId === "No Elector Found for this Constituency" ? (
          <NoElection data={"No Elector Found for this Constituency"} />
        ): (
          ""
        )}
      </LeftMenu>
    </>
  );
}
